// SPDX-License-Identifier: AGPL-3.0-or-later

import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {shouldShowPremiumFeatures} from '@app/features/premium/utils/PremiumUtils';
import {PlutoniumUpsell} from '@app/features/ui/plutonium_upsell/PlutoniumUpsell';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const PerGuildPremiumUpsell = observer(() => {
	const showPremium = shouldShowPremiumFeatures();
	return (
		<PlutoniumUpsell>
			{showPremium ? (
				<Trans>
					Customizing your avatar, banner, accent color, and bio for individual communities requires{' '}
					{PREMIUM_PRODUCT_NAME}. Community nickname and pronouns are free for everyone.
				</Trans>
			) : (
				<Trans>
					Customizing your avatar, banner, accent color, and bio for individual communities is not enabled on this
					instance. Community nickname and pronouns are available for everyone.
				</Trans>
			)}
		</PlutoniumUpsell>
	);
});
